import React, { useState } from "react";
import Application from "./Application";
import Axios from "axios";
import { apiurl } from "../../../path";
import CryptoJS from "crypto-js";
import ExcelJS from "exceljs";
import {
  setupDistrictTalukaData,
  applyDistrictTalukaDropdowns,
} from "../../../utils/districtTalukaDropdown";

const key = "#$@!#$%SoftMate%$#@Systems)(*#$(";
let token = localStorage.getItem("Token");

const AdminState = (props) => {
  const [allProposals, setAllProposals] = useState([]);
  const [alltechnicalCount, setAllTechnicalCount] = useState([]);
  const [allworkordercount, setAllWorkOrderCount] = useState([]);
  const [allbillcount, setAllBillCount] = useState([]);

  try {
    const encryptData = (data, key) => {
      if (!key || typeof key !== "string") {
        throw new Error("Encryption key is missing or invalid");
      }

      if (typeof data === "undefined") {
        throw new Error("Data to encrypt is undefined");
      }

      const dataString = JSON.stringify(data);
      return CryptoJS.AES.encrypt(dataString, key).toString();
    };

    const Login = async (formData) => {
      const { username, Password } = formData;
      console.log(username, Password);

      try {
        let encryptedUsername = encryptData(username, key);
        let encryptedPassword = encryptData(Password, key);

        let data = await fetch(apiurl + "/AdminLogin", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            AuthToken: token,
            key: key,
          },
          body: JSON.stringify({
            username: encryptedUsername,
            Password: encryptedPassword,
          }),
        });

        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in AdminLogin:", error);
      }
    };

    const validateOtp = async (otp, uniqid) => {
      try {
        let data = await fetch(apiurl + "/VerifyOTP", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            otp,
            uniqid,
          }),
        });

        data = await data.json();

        return data;
      } catch (error) {
        console.error("Error in ValidateOTP:", error);
        return {
          success: false,
          message: "Something went wrong",
        };
      }
    };

    const Usermenu = async () => {
      try {
        let data = await fetch(apiurl + "/GetMenu", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify(),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in Usermenu:", error);
      }
    };

    const GetBillFiles = async () => {
      try {
        let data = await fetch(apiurl + "/BillFiles", {
          method: "POST",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetRefundFiles:", error);
      }
    };

    const GetAdminPassKeys = async () => {
      try {
        let data = await fetch(apiurl + "/AdminPassKeys", {
          method: "GET",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetAdminPassKeys:", error);
      }
    };

    const AddAdminPassKeys = async (adminpasskeysdata) => {
      try {
        let data = await fetch(apiurl + "/AddAdminPassKeys", {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({ ...adminpasskeysdata }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in AddAdminPassKeys:", error);
      }
    };

    const DeleteAdminPassKeys = async (e) => {
      try {
        let data = await fetch(apiurl + "/DeleteAdminPassKeys", {
          method: "DELETE",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({ ...e }),
        });
      } catch (error) {
        console.error("Error in DeleteAdminPassKeys:", error);
      }
    };

    const EmployeeManagement = async (type, data) => {
      try {
        if (type === "Create") {
          let Creation = await fetch(
            apiurl + "/EmployeeManagement/CreateEmployee",
            {
              method: "post",
              headers: { "Content-Type": "Application/json", AuthToken: token },
              body: JSON.stringify({ ...data, type }),
            },
          );
          Creation = await Creation.json();
          return Creation;
        }
        if (type === "Update") {
          let Creation = await fetch(
            apiurl + "/EmployeeManagement/CreateEmployee",
            {
              method: "post",
              headers: { "Content-Type": "Application/json", AuthToken: token },
              body: JSON.stringify({ ...data, type }),
            },
          );
          Creation = await Creation.json();
          if (Creation) {
            return Creation;
          } else {
            alert("failed Edition");
          }
        }
        if (type === "Bulk") {
          let Creation = await fetch(
            apiurl + "/EmployeeManagement/CreateEmployee",
            {
              method: "post",
              headers: { "Content-Type": "Application/json", AuthToken: token },
              body: JSON.stringify({ data, type }),
            },
          );
          Creation = await Creation.json();
          if (Creation) {
            alert("Successfully Created");
          } else {
            alert("failed creation");
          }
        } else if (type === "View") {
          let Creation = await fetch(
            apiurl + "/EmployeeManagement/CreateEmployee",
            {
              method: "post",
              headers: { "Content-Type": "Application/json", AuthToken: token },
              body: JSON.stringify({ Searchparameter: data, type: "View" }),
            },
          );
          Creation = await Creation.json();
          return Creation;
        }
      } catch (error) {
        console.error("Error in EmployeeManagement:", error);
      }
    };

    const Roles = async (type, data, obj) => {
      try {
        if (type === "View") {
          let Creation = await fetch(apiurl + "/EmployeeManagement/Roles", {
            method: "post",
            headers: { "Content-Type": "Application/json", AuthToken: token },
            body: JSON.stringify({ type: "View" }),
          });
          Creation = await Creation.json();
          return Creation;
        } else if (type === "CreateRole") {
          let Creation = await fetch(apiurl + "/EmployeeManagement/Roles", {
            method: "post",
            headers: { "Content-Type": "Application/json", AuthToken: token },
            body: JSON.stringify({ ...data, type: "CreateRole", obj }),
          });
          Creation = await Creation.json();
          console.log(Creation);
          if (Creation) {
            alert("Your Role has been Successfully Created");
          }
          return Creation;
        }
      } catch (error) {
        console.error("Error in Roles:", error);
      }
    };

    const DepartmentHandler = async (type, data, obj) => {
      try {
        if (type === "view") {
          let Creation = await fetch(
            apiurl + "/EmployeeManagement/Department",
            {
              method: "post",
              headers: { "Content-Type": "Application/json", AuthToken: token },
              body: JSON.stringify({ type: "view" }),
            },
          );
          Creation = await Creation.json();
          return Creation;
        } else if (type === "insert") {
          let Creation = await fetch(
            apiurl + "/EmployeeManagement/Department",
            {
              method: "post",
              headers: { "Content-Type": "Application/json", AuthToken: token },
              body: JSON.stringify({
                Department_Name: data,
                type: type,
                Menu_Access: obj,
              }),
            },
          );
          Creation = await Creation.json();
          if (Creation) {
            alert("Your Department has been Successfully Created");
          }
          return Creation;
        }
      } catch (error) {
        console.error("Error in DepartmentHandler:", error);
      }
    };

    const EditRoleActions = async (type, RoleID, menu, menuset) => {
      try {
        let Creation = await fetch(apiurl + "/EmployeeManagement/EditRole", {
          method: "post",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ type: type, RoleID: RoleID, menu, menuset }),
        });
        Creation = await Creation.json();
        if (Creation === true) {
          alert("Your Role Editation has been complete");
        }
        return Creation;
      } catch (error) {
        console.error("Error in EditRoleActions:", error);
      }
    };

    const MisReports = async () => {
      try {
        let data = await fetch(apiurl + "/GetAuctions/MisReports", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({}),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in MisReports:", error);
      }
    };

    const CustomeReports = async (form) => {
      try {
        let data = await fetch(apiurl + "/GetAuctions/CustomeReports", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ ...form }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in CustomeReports:", error);
      }
    };

    const DashboardReports = async (daterep) => {
      try {
        let data = await fetch(apiurl + "/GetAuctions/DashboardReports", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ date: daterep }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in DashboardReports:", error);
      }
    };

    const CreateToken = async (fortoken) => {
      try {
        let data = await fetch(apiurl + "/Signature/CreateToken", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ fortoken: fortoken }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in CreateToken:", error);
      }
    };

    const AuthorizationFiles = async (fortoken) => {
      try {
        let data = await fetch(apiurl + "/Signature/Authorization", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ fortoken: fortoken }),
        });
        data = await data.json();

        return data;
      } catch (error) {
        console.error("Error in AuthorizationFiles:", error);
      }
    };

    const Authorizationverify = async (Tender_ID, EToken) => {
      try {
        let data = await fetch(apiurl + "/Signature/Authorizationverify", {
          method: "POST",
          headers: {
            "Content-Type": "Application/json",
            AuthToken: token,
            EToken: EToken,
          },
          body: JSON.stringify({ Tender_ID: Tender_ID }),
        });
        data = await data.json();

        return data;
      } catch (error) {
        console.error("Error in Authorizationverify:", error);
      }
    };

    const Authorizationreject = async (Tender_ID, EToken, Remark) => {
      try {
        let data = await fetch(apiurl + "/Signature/Authorizationreject", {
          method: "POST",
          headers: {
            "Content-Type": "Application/json",
            AuthToken: token,
            EToken: EToken,
          },
          body: JSON.stringify({ Tender_ID: Tender_ID, Remark: Remark }),
        });
        data = await data.json();

        return data;
      } catch (error) {
        console.error("Error in Authorizationreject:", error);
      }
    };

    // const GetVendors = async () => {
    //   try {
    //     let data = await fetch(apiurl + "/VendorManagement/GetVendorInfo", {
    //       method: "POST",
    //       headers: ({ AuthToken: token })
    //     });
    //     data = await data.json()
    //     return data;
    //   } catch (error) {
    //     console.error("Error in GetVendors:", error);
    //   }
    // }

    const GetVendors = async (UniqueID = null) => {
      try {
        console.log("Sending UniqueID:", JSON.stringify({ UniqueID }));
        let data = await fetch(apiurl + "/VendorManagement/GetVendorInfo", {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({ UniqueID }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetVendors:", error);
      }
    };

    const GetReport = async () => {
      console.log("called");
      try {
        let data = await fetch(apiurl + "/GetReport", {
          method: "GET",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetReport:", error);
      }
    };

    const AddBudget = async (Head, Fund, Approvals) => {
      try {
        const encrypted = encryptData({ Head, Fund, Approvals });
        let data = await fetch(apiurl + "/AddBudget", {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({ encrypted }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in AddBudget:", error?.message || error);
      }
    };

    const GetBudget = async () => {
      try {
        let data = await fetch(apiurl + "/GetBudget", {
          method: "GET",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetBudget:", error?.message || error);
      }
    };

    const UpdateBudget = async (id, updatedData) => {
      console.log(updatedData);
      try {
        let data = await fetch(`${apiurl}/UpdateBudget`, {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify(updatedData),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in UpdateBudget:", error?.message || error);
      }
    };

    const DeleteBudget = async (id) => {
      console.log(id);
      try {
        let data = await fetch(`${apiurl}/DeleteBudget`, {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ id }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in DeleteBudget:", error?.message || error);
      }
    };

    const BankMaster = async (type, formData) => {
      console.log("swapnil", type, formData);

      try {
        if (type == "get") {
          let Creation = await fetch(apiurl + "/banks", {
            method: "post",
            headers: { "Content-Type": "Application/json", AuthToken: token },
            body: JSON.stringify({ type: "get" }),
          });
          Creation = await Creation.json();
          return Creation;
        } else if (type == "insert") {
          let Creation = await fetch(apiurl + "/banks", {
            method: "post",
            headers: { "Content-Type": "Application/json", AuthToken: token },
            body: JSON.stringify({
              ...formData,
              type: type,
            }),
          });
          Creation = await Creation.json();
          return Creation;
        } else if (type == "edit") {
          let Creation = await fetch(apiurl + "/banks", {
            method: "post",
            headers: { "Content-Type": "Application/json", AuthToken: token },
            body: JSON.stringify({
              ...formData,
              type: type,
            }),
          });
          Creation = await Creation.json();
          return Creation;
        } else if (type == "delete") {
          let Creation = await fetch(apiurl + "/banks", {
            method: "post",
            headers: { "Content-Type": "Application/json", AuthToken: token },
            body: JSON.stringify({
              id: formData,
              type: type,
            }),
          });
          Creation = await Creation.json();
          return Creation;
        }
      } catch (error) {
        console.error("Error in BankMaster:", error);
      }
    };

    const UploadBills = async (formdata) => {
      try {
        let data = await fetch(apiurl + "/VendorManagement/UploadBill", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ ...formdata }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in UploadBills:", error);
      }
    };
    const TaxData = async (type, formdata) => {
      console.log("Formdata111", type, formdata);

      try {
        if (type === "get") {
          let Creation = await fetch(apiurl + "/Taxes", {
            method: "post",
            headers: { "Content-type": "Application/json", AuthToken: token },
            body: JSON.stringify({ type: "get" }),
          });
          Creation = await Creation.json();
          return Creation;
        } else if (type === "insert") {
          console.log("insert");

          let Creation = await fetch(apiurl + "/Taxes", {
            method: "post",
            headers: { "Content-type": "Application/json", AuthToken: token },
            body: JSON.stringify({
              ...formdata,
              type: type,
            }),
          });
          Creation = await Creation.json();
          return Creation;
        } else if (type === "edit") {
          console.log("edit");
          let Creation = await fetch(apiurl + "/Taxes", {
            method: "post",
            headers: { "Content-type": "Application/json", AuthToken: token },
            body: JSON.stringify({ ...formdata, type: type }),
          });
          Creation = await Creation.json();
          return Creation;
        } else if (type === "delete") {
          console.log("delete");
          let Creation = await fetch(apiurl + "/taxes", {
            method: "post",
            headers: { "Content-type": "Application/json", AuthToken: token },
            body: JSON.stringify({ type: type, ID: formdata }),
          });
          Creation = await Creation.json();
          return Creation;
        }
      } catch (error) {
        console.error("Error in TaxData:", error);
        return { message: "failed", error };
      }
    };

    const GetBills = async () => {
      try {
        let data = await fetch(apiurl + "/BillApprovals/GetBills", {
          method: "POST",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetBills:", error);
      }
    };

    // const ApproveBills = async (selectedBills, EToken) => {
    //   try {
    //     let data = await fetch(apiurl + "/BillApprovals/ApproveBills", {
    //       method: "POST",
    //       headers: { "Content-Type": "Application/json", AuthToken: token, "EToken": EToken },
    //       body: JSON.stringify({ selectedBills: selectedBills })
    //     });
    //     data = await data.json();
    //     return data;
    //   } catch (error) {
    //     console.error("Error in ApprovedBills:", error);
    //   }
    // };
    const ApproveBills = async (formData, EToken) => {
      try {
        let data = await fetch(apiurl + "/BillApprovals/ApproveBills", {
          method: "POST",
          headers: {
            AuthToken: token,
            EToken: EToken,
          },
          body: formData,
        });

        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in ApprovedBills:", error);
      }
    };
    const GetVendorBills = async () => {
      try {
        let data = await fetch(apiurl + "/VendorManagement/GetVendorBills", {
          method: "POST",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetVendorBills:", error);
      }
    };

    const GetTaxAmounts = async (type) => {
      try {
        let data = await fetch(apiurl + "/Dashboard/getTaxesAmount", {
          method: "POST",
          headers: { "Content-type": "Application/json", AuthToken: token },
          body: JSON.stringify({ typeofdata: type }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in getTaxes:", error);
      }
    };

    const getTaxes = async () => {
      try {
        let data = await fetch(apiurl + "/getTaxes", {
          method: "POST",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in getTaxes:", error);
      }
    };
    const getTaxAmountsByDate = async () => {
      try {
        let data = await fetch(apiurl + "/Dashboard/getTaxesAmountbyDate", {
          method: "POST",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in getTaxAmounts:", error);
      }
    };

    const GetLogReports = async () => {
      try {
        let data = await fetch(apiurl + "/GetLogReports", {
          method: "POST",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetRefundFiles:", error);
      }
    };
    const GetSteelRates = async () => {
      try {
        let data = await fetch(apiurl + "/GetSteelRates", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            AuthToken: token,
          },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetSteelRates:", error);
      }
    };

    const GetDateWiseData = async (
      projectId,
      type,
      typeofData,
      selectedWorkOrderType,
      location,
    ) => {
      try {
        console.log("datttttt", {
          projectId,
          location,
          type,
          typeofData,
          selectedWorkOrderType,
        });
        let data = await fetch(apiurl + "/Dashboard/getDateWiseData", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({
            projectId,
            location,
            type,
            typeofData,
            selectedWorkOrderType,
          }),
        });
        let res = await data.json();
        return res;
      } catch (error) {
        console.error("Error in GetDateWiseData:", error);
      }
    };

    const GetTotalTableData = async (
      projectId,
      type,
      typeofData,
      selectedWorkOrderType,
    ) => {
      try {
        let data = await fetch(apiurl + "/Dashboard/getTotalTableData", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({
            projectId: projectId,
            type: type,
            typeofData,
            selectedWorkOrderType: selectedWorkOrderType,
          }),
        });

        let res = await data.json();

        return res;
        console.log("getTotalTableData response", res.data);
        console.log(localStorage.getItem("token"));
      } catch (error) {
        console.error("Error in GetTotalTableData:", error);
      }
    };

    const AddProduct = async (type, formData) => {
      try {
        if (type === "get") {
          let response = await fetch(apiurl + "/Inventory/add_product", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              AuthToken: token,
            },
            body: JSON.stringify({ type: "get" }),
          });
          const data = await response.json();
          return data;
        }

        if (type === "insert") {
          let response = await fetch(apiurl + "/Inventory/add_product", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              AuthToken: token,
            },
            body: JSON.stringify({ ...formData, type }),
          });
          const data = await response.json();
          return data;
        }

        if (type === "update") {
          let response = await fetch(apiurl + "/Inventory/add_product", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              AuthToken: token,
            },
            body: JSON.stringify({ ...formData, type: "update" }),
          });
          const data = await response.json();
          return data;
        }

        if (type === "delete") {
          let response = await fetch(apiurl + "/Inventory/add_product", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              AuthToken: token,
            },
            body: JSON.stringify({ ID: formData.ID, type: "delete" }),
          });
          const data = await response.json();
          return data;
        }

        return { message: "invalid request" };
      } catch (error) {
        console.error("Error in AddProduct:", error);
        return { message: "failed", error };
      }
    };
    const PurchaseList = async (type, formData) => {
      try {
        if (type === "get") {
          let response = await fetch(apiurl + "/Inventory/PurchaseList", {
            method: "POST",
            headers: { "content-type": "application/json", AuthToken: token },
            body: JSON.stringify({ type: "get" }),
          });
          const data = await response.json();
          return data;
        }

        if (type === "insert") {
          let response = await fetch(apiurl + "/Inventory/PurchaseList", {
            method: "POST",
            headers: { "content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ ...formData, type }),
          });
          const data = await response.json();
          return data;
        }
        if (type === "update") {
          let response = await fetch(apiurl + "/Inventory/PurchaseList", {
            method: "POST",
            headers: { "content-type": "application/json", AuthToken: token },
            body: JSON.stringify({ ...formData, type: "update" }),
          });
          const data = await response.json();
          return data;
        }
        if (type === "delete") {
          let response = await fetch(apiurl + "/Inventory/PurchaseList", {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ ID: formData.ID, type: "delete" }),
          });
          const data = await response.json();
          return data;
        }
        return { message: "invalid request" };
      } catch (error) {
        return { message: "failed", error };
      }
    };

    const GRCreation = async (forminf) => {
      try {
        let response = await fetch(`${apiurl}/VendorManagement/GRCreation`, {
          method: "POST",
          headers: { AuthToken: token },
          body: forminf,
        });
        const data = await response.json();
        return data;
      } catch (error) {
        console.error("Error in GRCreation:", error);
        throw error;
      }
    };

    const AdministrativeApprovalCreation = async (forminf) => {
      try {
        let response = await fetch(
          `${apiurl}/VendorManagement/AdministrativeApprovalCreation`,
          {
            method: "POST",
            headers: { AuthToken: token },
            body: forminf,
          },
        );
        const data = await response.json();
        return data;
      } catch (error) {
        console.error("Error in GRCreation:", error);
        throw error;
      }
    };

    const ProposalCreation = async (forminf) => {
      try {
        let response = await fetch(
          `${apiurl}/VendorManagement/CreateProposal`,
          {
            method: "POST",
            headers: { AuthToken: token },
            body: forminf,
          },
        );
        const data = await response.json();
        return data;
      } catch (error) {
        console.error("Error in Proposal Creation:", error);
        throw error;
      }
    };

    const HeadCreation = async (forminf) => {
      try {
        let response = await fetch(
          `${apiurl}/VendorManagement/BudgetHeadCreation`,
          {
            method: "POST",
            headers: { AuthToken: token },
            body: forminf,
          },
        );
        const data = await response.json();
        return data;
      } catch (error) {
        console.error("Error in HeadCreation:", error);
        throw error;
      }
    };

    const GetProjectInfo = async (ProjectID, type, typeofData) => {
      try {
        let data = await fetch(`${apiurl}/VendorManagement/GetProjectInfo`, {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({
            ProjectID: ProjectID,
            type: type,
            typeofData,
          }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetProjectInfo:", error);
      }
    };

    const DeductionOperation = async (deductionData, type) => {
      try {
        let data = await fetch(
          `${apiurl}/VendorManagement/DeductionOperation`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ deductionData: deductionData, type: type }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in DeductionOperation:", error);
      }
    };

    const GetBudgetHeadInfo = async (HeadID, type) => {
      try {
        let data = await fetch(`${apiurl}/VendorManagement/GetBudgetHeadInfo`, {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({ HeadID: HeadID, type: type }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetBudgetHeadInfo:", error);
      }
    };

    const WorkOrderCreation = async (forminf) => {
      try {
        let response = await fetch(
          `${apiurl}/VendorManagement/WorkOrderCreation`,
          {
            method: "POST",
            headers: { AuthToken: token },
            body: forminf,
          },
        );
        const data = await response.json();
        return data;
      } catch (error) {
        console.error("Error in WorkOrderCreation:", error);
        throw error;
      }
    };

    const BudgetEstimation = async (forminf) => {
      try {
        let res = await fetch(`${apiurl}/VendorManagement/BudgetEstimation`, {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify(forminf),
        });
        const data = await res.json();
        return data;
      } catch (err) {
        console.log(err);
      }
    };

    const DemandRequest = async (forminf) => {
      try {
        let res = await fetch(`${apiurl}/VendorManagement/DemandRequest`, {
          method: "POST",
          headers: { AuthToken: token },
          body: forminf,
        });
        const data = await res.json();
        return data;
      } catch (err) {
        console.log(err);
      }
    };

    const DemandCreation = async (forminf) => {
      try {
        let response = await fetch(
          `${apiurl}/VendorManagement/DemandGeneration`,
          {
            method: "POST",
            headers: { AuthToken: token },
            body: forminf,
          },
        );

        const data = await response.json();
        return data;
      } catch (error) {
        console.error("Error in WorkOrderCreation:", error);
        throw error;
      }
    };

    // const ReleaseFDUTF = async (forminf) => {
    //   try {
    //     let response = await fetch(`${apiurl}/VendorManagement/ReleaseFDUTF`, {
    //       method: 'POST',
    //       headers: { AuthToken: token },
    //       body: forminf,
    //     });
    //     const data = await response.json();
    //     return data;
    //   } catch (error) {
    //     console.error('Error in ProjectCreation:', error);
    //     throw error;
    //   }
    // }

    const ReleaseFDUTF = async (forminf, type) => {
      try {
        let response = await fetch(`${apiurl}/VendorManagement/ReleaseFDUTF`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            AuthToken: token,
          },
          body: JSON.stringify({ forminf: forminf, type: type }),
        });
        const data = await response.json();
        return data;
      } catch (error) {
        console.error("Error in ProjectCreation:", error);
        throw error;
      }
    };

    const ViewAllReleaseFDUTF = async () => {
      try {
        let response = await fetch(
          `${apiurl}/VendorManagement/ViewAllReleaseFDUTF`,
          {
            method: "POST",
            headers: { AuthToken: token },
          },
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Parse the response body
        const data = await response.json();
        return data;
      } catch (error) {
        console.error("Fetch error:", error);
        throw error;
      }
    };

    // const GetDemandApproval = async () => {
    //   try {
    //     let data = await fetch(`${apiurl}/VendorManagement/GetDemandApproval`, {
    //       method: "GET",
    //       headers: { AuthToken: token },
    //     });
    //     data = await data.json();
    //     return data;
    //   } catch (error) {
    //     console.error("Error in GetOpenTenders:", error);
    //   }
    // };
    const GetDemandApproval = async (type = "") => {
      try {
        let data = await fetch(`${apiurl}/VendorManagement/GetDemandApproval`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            AuthToken: token,
          },
          body: JSON.stringify({
            type: type,
          }),
        });

        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetDemandApproval:", error);
      }
    };
    const GetAllProjectList = async () => {
      try {
        let data = await fetch(apiurl + "/VendorManagement/GetAllProjectList", {
          method: "POST",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetAllProjectList:", error);
      }
    };

    const GetWorksByGR = async (grid) => {
      try {
        let response = await fetch(apiurl + "/VendorManagement/GetWorksByGR", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            AuthToken: token,
          },
          body: JSON.stringify({ GRID: grid }),
        });
        const data = await response.json();
        return data;
      } catch (error) {
        console.error("Error in GetWorksByGR service:", error);
      }
    };

    const GetAllContractorList = async () => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetAllContractorList",
          {
            method: "POST",
            headers: { AuthToken: token },
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetAllProjectList:", error);
      }
    };

    const GetAllBudgetHeadList = async () => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetAllBudgetHeadList",
          {
            method: "POST",
            headers: { AuthToken: token },
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetAllProjectList:", error);
      }
    };

    const GetAllBudgetEstimationList = async () => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetAllBudgetEstimationList",
          {
            method: "POST",
            headers: { AuthToken: token },
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetAllProjectList:", error);
      }
    };

    const GetAllWorkOrderList = async () => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetAllWorkOrderList",
          {
            method: "POST",
            headers: { AuthToken: token },
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetAllProjectList:", error);
      }
    };

    const GetProjectTotal = async () => {
      try {
        let data = await fetch(apiurl + "/Dashboard/getTotalProject", {
          method: "POST",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetProjectTotal:", error);
      }
    };
    const GetTotalAmountAvailbaleInBank = async () => {
      try {
        let data = await fetch(apiurl + "/Dashboard/getTotalBalanceinBank", {
          method: "POST",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetProjectTotal:", error);
      }
    };
    const GetLiabilityTotal = async () => {
      try {
        let data = await fetch(apiurl + "/Dashboard/GetTotalLiabilities", {
          method: "POST",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetProjectTotal:", error);
      }
    };

    const FundAllomentOperation = async (type, formdata) => {
      try {
        let data = await fetch(apiurl + "/VendorManagement/FundAllotment", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ type: type, data: formdata }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetProjectTotal:", error);
      }
    };
    const getGrnData = async (type, formData) => {
      try {
        if (type === "insert") {
          const response = await fetch(apiurl + "/Inventory/getGrnData", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              AuthToken: token,
            },
            body: JSON.stringify({ ...formData, type: "insert" }),
          });
          return await response.json();
        }
        return { message: "invalid request type" };
      } catch (error) {
        return { message: "failed", error };
      }
    };
    const getBindata = async () => {
      try {
        const response = await fetch(apiurl + "/Inventory/getBinData", {
          method: "POST",
          headers: {
            AuthToken: token,
          },
        });
        return await response.json();
      } catch (error) {
        console.error("Error in getBindata:", error);
        return [];
      }
    };
    const AddExpenses = async (expenses, type) => {
      console.log("expenses", expenses, type);

      try {
        if (type === "insert") {
          const response = await fetch(
            apiurl + "/ExpenseManagement/AddExpenses",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                AuthToken: token,
              },
              body: JSON.stringify({ expenses, type: "insert" }),
            },
          );
          return await response.json();
        }
        if (type === "get") {
          const response = await fetch(
            apiurl + "/ExpenseManagement/AddExpenses",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                AuthToken: token,
              },
              body: JSON.stringify({ type: "get" }),
            },
          );
          return await response.json();
        }
        if (type === "expenselist") {
          const response = await fetch(
            apiurl + "/ExpenseManagement/AddExpenses",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                AuthToken: token,
              },
              body: JSON.stringify({ type: "expenselist" }),
            },
          );
          return await response.json();
        }
        if (type === "getRequests") {
          const response = await fetch(
            apiurl + "/ExpenseManagement/AddExpenses",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                AuthToken: token,
              },
              body: JSON.stringify({ type: "getRequests" }),
            },
          );
          return await response.json();
        }
        return { message: "invalid request type" };
      } catch (error) {
        return { message: "failed", error };
      }
    };

    const ApprovedOrRejectExpense = async (
      selectedExpenseid,
      approvedAmount,
      status,
    ) => {
      console.log("expenses", selectedExpenseid, approvedAmount, status);

      try {
        const response = await fetch(
          apiurl + "/ExpenseManagement/AccpetorRejectExpense",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              AuthToken: token,
            },
            body: JSON.stringify({ selectedExpenseid, approvedAmount, status }),
          },
        );
        return await response.json();
      } catch (error) {
        return { message: "failed", error };
      }
    };
    const getecsreponsefiles = async () => {
      try {
        let data = await fetch(apiurl + "/BillApprovals/GetEcsReposnseFiles", {
          method: "POST",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in getecsreponsefiles:", error);
      }
    };
    const getecsresponse = async () => {
      try {
        let data = await fetch(apiurl + "/getECSResponse", {
          method: "POST",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in getecsresponse:", error);
      }
    };
    const GetCashBookReport = async (type, formData) => {
      try {
        const response = await fetch(apiurl + "/GetCashBookReports", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            AuthToken: token,
          },
        });
        let data = await response.json();
        return data;
      } catch (error) {
        console.error("Error:", error);
        return null;
      }
    };

    const getGRNPendingList = async (id, type) => {
      try {
        if (id) {
          const response = await fetch(
            apiurl + "/VendorManagement/getGRNPendingList",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                AuthToken: token,
              },
              body: JSON.stringify({ id: id, type: type }),
            },
          );
          let data = await response.json();
          return data;
        }
        const response = await fetch(
          apiurl + "/VendorManagement/getGRNPendingList",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              AuthToken: token,
            },
          },
        );
        let data = await response.json();
        return data;
      } catch (error) {
        console.error("Error:", error);
        return null;
      }
    };

    const GetTechnicalInwardsList = async (type, id) => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetTechnicalInwardsList",
          {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ type: type, id: id }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetAllProjectList:", error);
      }
    };

    const GetAdminApprovalInwardsList = async (type, id) => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetAdminApprovalInwardsList",
          {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ type: type, id: id }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetAllProjectList:", error);
      }
    };
    const GetProposalInwardsList = async (type, id, idType, departmentId = "") => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetProposalInwardsList",
          {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ type: type, id: id, idType: idType, departmentId: departmentId }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetAllProjectList:", error);
      }
    };
    const GetWorkOrderInwardsList = async (type, id, departmentId = "") => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetWorkOrderInwardsList",
          {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ type: type, id: id, departmentId: departmentId }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetWorkOrderInwardsList:", error);
      }
    };
    const GetDemandRequestInwardsList = async (type, id) => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/DemandRequestInwardsList",
          {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ type: type, id: id }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in DemandRequestInwardsList:", error);
      }
    };
    const sanctionCreation = async (formData) => {
      console.log("formData", formData);

      try {
        const response = await fetch(
          apiurl + "/VendorManagement/TechnicalSaction",
          {
            method: "POST",
            headers: {
              AuthToken: token,
            },
            body: formData,
          },
        );
        let data = await response.json();
        return data;
      } catch (error) {
        console.error("Error:", error);
        return null;
      }
    };
    const TechnicalSanctionApprove = async (id, type, remark) => {
      console.log(id);

      try {
        let data = await fetch(
          apiurl + "/BillApprovals/TechnicalSanctionApprove",
          {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ id: id, type: type, remark: remark }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetAllProjectList:", error);
      }
    };
    const AdministrativeApproveOperation = async (id, type, remark) => {
      try {
        let data = await fetch(
          apiurl + "/BillApprovals/AdminimistrativeApproveOperation",
          {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ id: id, type: type, remark: remark }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetAllProjectList:", error);
      }
    };
    const ProposalApprovalOperation = async (
      id,
      type,
      remark,
      EToken,
      worknames,
      proposaldata,
    ) => {
      console.log(id);

      try {
        let data = await fetch(
          apiurl + "/BillApprovals/ProposalApprovalOperation",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              AuthToken: token,
              EToken: EToken,
            },
            body: JSON.stringify({
              id: id,
              type: type,
              remark: remark,
              worknames: worknames,
              proposaldata: proposaldata,
            }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetAllProjectList:", error);
      }
    };
    const WorkOrderApprovalOperation = async (id, type, remark) => {
      console.log(id);

      try {
        let data = await fetch(
          apiurl + "/BillApprovals/WorkOrderApprovalOperation",
          {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ id: id, type: type, remark: remark }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in WorkOrderApprovalOperation:", error);
      }
    };
    const DemandRequestApprovalOperation = async (id, type, remark) => {
      console.log(id);

      try {
        let data = await fetch(
          apiurl + "/BillApprovals/DemandRequestApprovalOperation",
          {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ id: id, type: type, remark: remark }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in DemandRequestApprovalOperation:", error);
      }
    };

    const ProgressReportApprovalOperation = async (payload) => {
      // console.log(id);

      try {
        let data = await fetch(
          apiurl + "/BillApprovals/PhysicalProgressApprovalOperation",
          {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify(payload),
            // body: JSON.stringify({ id: id, type: type, remark: remark,MHUIDINfo:findedMHUID, physicalval:physicalvalue }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in DemandRequestApprovalOperation:", error);
      }
    };

    const GetAllUlb = async () => {
      try {
        let data = await fetch(apiurl + "/VendorManagement/GetAllUlb", {
          method: "POST",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetAllUlb:", error);
      }
    };

    const GetGRPendingListForApprove = async () => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetGRPendingListForApprove",
          {
            method: "POST",
            headers: { AuthToken: token },
          },
        );
        data = await data.json();

        return data;
      } catch (error) {
        console.error("Error in GetBills:", error);
      }
    };
    const ApproveGR = async (selectedBills, type, remark, EToken) => {
      try {
        let data = await fetch(apiurl + "/BillApprovals/ApproveGR", {
          method: "POST",
          headers: {
            "Content-Type": "Application/json",
            AuthToken: token,
            EToken: EToken,
          },
          body: JSON.stringify({
            selectedBills: selectedBills,
            type: type,
            remark: remark,
          }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in ApprovedBills:", error);
      }
    };

    const GetProposallist = async (type, typeofData, projectId, departmentId = "") => {
      console.log("GetProposallist called with parameters:", departmentId);
      try {
        let data = await fetch(apiurl + "/VendorManagement/GetProposallist", {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({ type, typeofData, projectId, departmentId }),
        });
        data = await data.json();
        console.log("for proposalcount dataaa", data);
        return data;
      } catch (error) {
        console.error("Error in GetProposallist:", error);
      }
    };

    //--> old code
    // const GetProposallist = async () => {
    //   try {
    //     let data = await fetch(apiurl + "/VendorManagement/GetProposallist", {
    //       method: "POST",
    //       headers: { AuthToken: token },
    //     });
    //     data = await data.json();
    //     console.log("for proposalcount dataaa", data);
    //     return data;
    //   } catch (error) {
    //     console.error("Error in GetProposallist:", error);
    //   }
    // };

    const UploadFDUTF = async (forminf) => {
      console.log("form111", forminf);

      try {
        let response = await fetch(`${apiurl}/VendorManagement/UploadFDUTF`, {
          method: "POST",
          headers: {
            AuthToken: token,
          },
          body: forminf,
        });
        const data = await response.json();
        return data;
      } catch (error) {
        console.error("Error in UploadFDUTF:", error);
        throw error;
      }
    };
    const GetPrograsslist = async () => {
      try {
        let data = await fetch(apiurl + "/VendorManagement/GetPrograsslist", {
          method: "POST",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetPrograsslist:", error);
      }
    };
    const GetBudgetEstimationInwardList = async (type, id) => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/BudgetEstimationInwardList",
          {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ type: type, id: id }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in DemandRequestInwardsList:", error);
      }
    };

    const BudgetEstimationApprovalOperation = async (
      selectedBills,
      type,
      remark,
      EToken,
    ) => {
      try {
        let data = await fetch(
          apiurl + "/BillApprovals/BudgetEstimationApprovalOperation",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              AuthToken: token,
              EToken: EToken,
            },
            body: JSON.stringify({
              id: selectedBills,
              type: type,
              remark: remark,
            }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in ApprovedBills:", error);
      }
    };

    const TechnicalOutwards = async (
      type,
      WorkOrderType = "",
      typeofData,
      projectId,
    ) => {
      try {
        console.log("iddd", projectId);

        let data = await fetch(apiurl + "/VendorManagement/TechnicalOutwards", {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({
            type: type,
            WorkOrderType,
            typeofData,
            projectId,
          }),
        });
        data = await data.json();
        console.log("setTechnicalCount checking", data.length);
        return data;
      } catch (error) {
        console.error("Error in TechnicalOutwards:", error);
      }
    };

    //--> old code
    // const TechnicalOutwards = async (type, WorkOrderType = "", typeofData) => {
    //   try {
    //     let data = await fetch(apiurl + "/VendorManagement/TechnicalOutwards", {
    //       method: "POST",
    //       headers: { "Content-Type": "application/json", AuthToken: token },
    //       body: JSON.stringify({ type: type, WorkOrderType, typeofData }),
    //     });
    //     data = await data.json();
    //     console.log("setTechnicalCount checking", data.length);
    //     return data;
    //   } catch (error) {
    //     console.error("Error in TechnicalOutwards:", error);
    //   }
    // };

    const WorkOutwards = async (
      WorkOrderType = "",
      typeofData,
      type,
      projectId,
    ) => {
      try {
        let data = await fetch(apiurl + "/VendorManagement/WorkOutwards", {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({
            WorkOrderType,
            typeofData,
            type,
            projectId,
          }),
        });
        data = await data.json();
        console.log("setAdminstrative checking", data.length);
        return data;
      } catch (error) {
        console.error("Error in WorkOutwards:", error);
      }
    };

    //--> old code
    // const WorkOutwards = async (WorkOrderType = "") => {
    //   try {
    //     let data = await fetch(apiurl + "/VendorManagement/WorkOutwards", {
    //       method: "POST",
    //       headers: { AuthToken: token },
    //       body: JSON.stringify({
    //         WorkOrderType,
    //       }),
    //     });
    //     data = await data.json();
    //     console.log("setAdminstrative checking", data.length);
    //     return data;
    //   } catch (error) {
    //     console.error("Error in WorkOutwards:", error);
    //   }
    // };

    const SchemeCreation = async (type, formdata) => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/SchemeCreationOperation",
          {
            method: "POST",
            headers: { "Content-Type": "Application/json", AuthToken: token },
            body: JSON.stringify({ type: type, data: formdata }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetProjectTotal:", error);
      }
    };
    const GetAllSchemes = async () => {
      try {
        let data = await fetch(apiurl + "/GetAllSchemes", {
          method: "POST",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetAllSchemes:", error);
      }
    };

    const FinanceGRApproveOperation = async (
      selectedBills,
      type,
      remark,
      EToken,
    ) => {
      try {
        let data = await fetch(
          apiurl + "/BillApprovals/FinanceGRApprovalOperation",
          {
            method: "POST",
            headers: {
              "Content-Type": "Application/json",
              AuthToken: token,
              EToken: EToken,
            },
            body: JSON.stringify({
              id: selectedBills,
              type: type,
              remark: remark,
            }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in ApprovedBills:", error);
      }
    };

    const GetFinanceGRListForApprove = async () => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetFinanceGRListForApprove",
          {
            method: "POST",
            headers: { AuthToken: token },
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetBills:", error);
      }
    };

    const GetProgressReportInwardList = async (type, id) => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/ProgressReportInwardsList",
          {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ type: type, id: id }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetProgressReportInwardList:", error);
      }
    };

    const CreateMapCoordinateforProposal = async (type, formdata) => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/MapCoordinateforProposal",
          {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ type: type, formdata: formdata }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetProgressReportInwardList:", error);
      }
    };

    const Getyears = async (type, id, HeadName) => {
      try {
        let data = await fetch(apiurl + "/VendorManagement/Getyears", {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({ type: type, id: id, HeadName: HeadName }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetAllData:", error);
      }
    };

    const GetWorkStatusReportData = async (
      headCode,
      district,
      taluka,
      year,
    ) => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetWorkStatusMISReport",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              AuthToken: token,
            },
            body: JSON.stringify({
              headCode: headCode,
              district: district,
              taluka: taluka,
              year: year,
            }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetWorkStatusReportData:", error);
      }
    };

    const GetDemandOutwards = async () => {
      try {
        const data = await fetch(
          apiurl + "/VendorManagement/GetDemandOutwards",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              AuthToken: token,
            },
          },
        );
        const result = await data.json();
        return result;
      } catch (error) {
        console.error("Error in GetDemandOutwards:", error);
        return [];
      }
    };

    const GetAdministativeoutwards = async () => {
      try {
        const response = await fetch(
          apiurl + "/VendorManagement/GetAdministativeoutwards",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              AuthToken: token,
            },
            body: JSON.stringify({}),
          },
        );
        const data = await response.json();
        return data;
      } catch (error) {
        console.error("Error in GetAdministativeoutwards:", error);
        return [];
      }
    };

    const EditDraftCopy = async (formdata) => {
      try {
        let data = await fetch(apiurl + "/VendorManagement/EditDraft", {
          method: "POST",
          headers: { AuthToken: token },
          body: formdata,
        });
        data = await data.json();
        console.log(data);
        return data;
      } catch (error) {
        console.error("Error in EditAuction:", error);
      }
    };

    async function validatecaptcha(uniqid, text) {
      const encrypted = encryptData({ uniqid, text }, key); // Ensure you pass the correct key

      const headersList = {
        Accept: "*/*",
        "Content-Type": "application/json",
      };

      const bodyContent = JSON.stringify({ data: encrypted });

      try {
        const response = await fetch(apiurl + "/Captcha/ValidateCaptcha", {
          method: "POST",
          body: bodyContent,
          headers: headersList,
        });

        if (!response.ok) {
          throw new Error("Captcha validation failed");
        }

        return await response.json(); // Should return something like { valid: true } or false
      } catch (error) {
        console.error("Captcha validation error:", error);
        return false;
      }
    }

    async function getcaptcha() {
      let headersList = {
        Accept: "*/*",
        "User-Agent": "Thunder Client (https://www.thunderclient.com)",
      };
      let response = await fetch(apiurl + "/Captcha/captcha", {
        method: "GET",
        headers: headersList,
      });
      let data = await response.json();
      return data;
    }

    const GramManchitraData = async (Manchitradata) => {
      try {
        let data = await fetch(
          "http://103.110.127.134:4000/SoftmateManagement/GramManchitraData",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ Manchitradata: Manchitradata }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GramManchitraData:", error);
      }
    };

    const GetGramPanchayatCodes = async (GPname, type) => {
      try {
        let data = await fetch(apiurl + "/VendorManagement/GetGramPanchayat", {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({ GPname: GPname, type: type }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GramManchitraData:", error);
      }
    };
    const TypesOfWork = async (HeadName) => {
      try {
        let data = await fetch(apiurl + "/VendorManagement/TypeOfWorks", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ HeadName: HeadName }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GramManchitraData:", error);
      }
    };

    const GetTechnicalCoordinates = async (ProposalId, projectId) => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetTechnicalSanctionCoordinate",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              ProposalId: ProposalId,
              projectId: projectId,
            }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GramManchitraData:", error);
      }
    };

    const GetOverLappingData = async (proposalUID) => {
      try {
        console.log("Sending body:", { proposalUID });
        const data = await fetch(
          apiurl + "/VendorManagement/GetOverlappingData",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              AuthToken: token,
            },
            body: JSON.stringify({
              proposalUID,
            }),
          },
        );
        const result = await data.json();
        return result;
      } catch (error) {
        console.error("Error in GetOverLappingData:", error);
        return [];
      }
    };

    const FetchECSFiles = async () => {
      try {
        let data = await fetch(apiurl + `/ECSReport/FetchECSFiles`, {
          method: "GET",
          headers: { "Content-Type": "Application/Json", AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("error in AuctionECS:", error);
      }
    };

    const FetchECSReport = async (FileName) => {
      try {
        let data = await fetch(apiurl + "/ECSReport/FetchECSReport", {
          method: "POST",
          headers: { "Content-Type": "Application/Json", AuthToken: token },
          body: JSON.stringify({ fileName: FileName }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("error in AuctionECS:", error);
      }
    };

    const FetchECSDashboardReport = async (FileName) => {
      try {
        let data = await fetch(apiurl + "/ECSReport/FetchECSDashboardReport", {
          method: "GET",
          headers: { "Content-Type": "Application/Json", AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("error in AuctionECS:", error);
      }
    };

    const FetchFilesForUpdate = async (FileName) => {
      try {
        let data = await fetch(apiurl + "/ECSReport/FetchFilesForUpdate", {
          method: "GET",
          headers: { "Content-Type": "Application/Json", AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("error in AuctionECS:", error);
      }
    };

    const saveECSFile = async (payload) => {
      console.log("saveECSFile payload", payload);
      try {
        let data = await fetch(apiurl + "/BillApprovals/saveECSFile", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify(payload),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in ApprovedBills:", error);
      }
    };

    const sanitizeFileUrl = (fileurl) => {
      if (!fileurl) return "";
      const cleaned = fileurl
        .toString()
        .trim()
        .replace(/^[\{\s]+|[\}\s]+$/g, "");
      const parts = cleaned.split("/").filter(Boolean);
      return parts.map((p) => encodeURIComponent(p)).join("/");
    };

    const SecureFileFetching = async (fileurl) => {
      try {
        const safePath = decodeURIComponent(sanitizeFileUrl(fileurl));

        console.log("1. fileurl:", fileurl);
        console.log("2. safePath:", safePath);

        if (!safePath) throw new Error("Invalid file path");

        const fullUrl = `${apiurl.replace(/\/$/, "")}/${safePath}`;

        console.log("3. fullUrl:", fullUrl);

        const response = await fetch(fullUrl, {
          method: "GET",
          headers: {
            AuthToken: token,
          },
        });

        console.log("4. response status:", response.status);

        if (!response.ok) {
          throw new Error(
            `Access denied or file not found (status ${response.status})`,
          );
        }

        console.log("5. Checking Excel condition...");

        if (
          safePath.toLowerCase() ===
          "ProposalFile/proposal state wise excel format.xlsx".toLowerCase()
        ) {
          console.log("6. ✅ EXCEL CONDITION MATCHED");

          const arrayBuffer = await response.arrayBuffer();

          console.log("7. Excel ArrayBuffer received");

          const workbook = new ExcelJS.Workbook();
          await workbook.xlsx.load(arrayBuffer);

          console.log("8. ExcelJS workbook loaded");

          const worksheet = workbook.getWorksheet("Sheet1");

          console.log("9. Sheet1:", worksheet);

          if (!worksheet) {
            throw new Error("Sheet1 not found in Excel template");
          }

          setupDistrictTalukaData(workbook);

          console.log("10. MasterData setup completed");

          applyDistrictTalukaDropdowns(workbook, worksheet, 2, 1000);

          console.log("11. District/Taluka dropdowns applied");

          console.log(
            "12. District validation:",
            worksheet.getCell("D2").dataValidation,
          );

          console.log(
            "13. Taluka validation:",
            worksheet.getCell("E2").dataValidation,
          );

          const buffer = await workbook.xlsx.writeBuffer();

          console.log("14. Excel buffer created");

          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          const fileURL = URL.createObjectURL(blob);

          // window.open(fileURL, "_blank");
          const link = document.createElement("a");
          link.href = fileURL;
          link.download = "proposalformat.xlsx";

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          setTimeout(() => {
            URL.revokeObjectURL(fileURL);
          }, 10000);

          return;
        }

        console.log("15. ❌ Not Excel → normal file handling");

        const blob = await response.blob();
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL, "_blank");
      } catch (error) {
        console.error("Error fetching file:", error);
        alert(error.message);
      }
    };

    const GetProgressReportOutwardsFucntion = async (type, id) => {
      console.log("progress");
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetProgressReportOutwards",
          {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ type: type, id: id }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetProgressReportOutwards:", error);
      }
    };

    const GetDemandRequestOutwardsFunction = async (type, id) => {
      console.log("progress");
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetDemandRequestOutwards",
          {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ type: type, id: id }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetProgressReportOutwards:", error);
      }
    };

    const NotificationHandler = async (type, id = null) => {
      try {
        let data = await fetch(apiurl + "/ECSReport/NotificationHandler", {
          method: "POST",
          headers: { "Content-Type": "Application/Json", AuthToken: token },
          body: JSON.stringify({ type, id }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("❌ Error in NotificationHandler:", error);
        return { success: false, message: "Network or server error" };
      }
    };

    const GRProposalCreationFunction = async (formData) => {
      console.log("progress");
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GRProposalCreation",
          {
            method: "POST",
            headers: { AuthToken: token },
            body: formData,
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetProgressReportOutwards:", error);
      }
    };

    const CheckGRNumberFunction = async (GRNumber) => {
      console.log("Checking GR Number");

      try {
        let response = await fetch(apiurl + "/VendorManagement/checkGRNumber", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            AuthToken: token,
          },
          body: JSON.stringify({ GRNumber }),
        });

        response = await response.json();
        return response;
      } catch (error) {
        console.error("Error in CheckGRNumberFunction:", error);
      }
    };

    const GetProposalStatusList = async (departmentId = "") => {
      try {
        let data = await fetch(apiurl + "/Dashboard/get-proposal-status-list", {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({ departmentId }),
        });

        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetProposalStatusList:", error);
      }
    };
    
    const GetAllProposalList = async () => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetAllProposalStatusList",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              AuthToken: token,
            },
          },
        );

        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetProposalStatusList:", error);
      }
    };
    const GetGRbyProposalId = async (WorkuniqeID1) => {
      try {
        let data = await fetch(apiurl + "/VendorManagement/GetGRbyproposalID", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            AuthToken: token,
          },
          body: JSON.stringify({ WorkuniqeID: WorkuniqeID1 }),
        });

        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetProposalStatusList:", error);
      }
    };
    const RaiseAcomplaint = async (formData) => {
      console.log(formData);
      let data = await fetch(`${apiurl}/Grievance/RaiseAComplaint`, {
        method: "POST",
        headers: {
          AuthToken: token,
        },
        body: formData,
      });
      data = await data.json();
      console.log(data);
      return data;
    };
    const GetComplaints = async () => {
      let data = await fetch(`${apiurl}/Grievance/GetComplaints`, {
        method: "POST",
        headers: { AuthToken: token },
      });
      data = await data.json();
      return data;
    };

    const UserTicketInfo = async () => {
      let data = await fetch(`${apiurl}/Grievance/UserTicketInfo`, {
        method: "POST",
        headers: { AuthToken: token },
      });
      data = await data.json();
      console.log(data);
      return data;
    };
    const ShowMessages = async (Ticketid) => {
      console.log(Ticketid);
      let data = await fetch(`${apiurl}/Grievance/ShowMessages`, {
        method: "POST",
        headers: { "Content-Type": "application/json", AuthToken: token },
        body: JSON.stringify({ Ticketid: Ticketid }),
      });
      let res = await data.json();
      console.log(res);
      return res;
    };
    const SendTicketChatDMA = async (Ticketid, ChatMessage) => {
      let data = await fetch(`${apiurl}/Grievance/SendChatMessageFromDMA`, {
        method: "Post",
        headers: { "Content-Type": "application/json", AuthToken: token },
        body: JSON.stringify({ Ticketid: Ticketid, ChatMessage: ChatMessage }),
      });
      data = await data.json();
      console.log(data);
      return data;
    };
    async function GetTicketInfos(Ticketid) {
      let data = await fetch(`${apiurl}/Grievance/ViewTicketInfo`, {
        method: "POST",
        headers: { "Content-Type": "application/json", AuthToken: token },
        body: JSON.stringify({ Ticketid: Ticketid }),
      });
      let res = await data.json();
      console.log(res);
      return res;
    }
    async function CloseTickets(Ticketid, newStatus) {
      let data = await fetch(`${apiurl}/Grievance/CloseTheTicket`, {
        method: "POST",
        headers: { "Content-Type": "application/json", AuthToken: token },
        body: JSON.stringify({ Ticketid: Ticketid, newStatus: newStatus }),
      });
      let res = await data.json();
      console.log(res);
      return res;
    }
    async function ReopentheTicket(Ticketid, newStatus) {
      let data = await fetch(`${apiurl}/Grievance/ReopenTheTicket`, {
        method: "POST",
        headers: { "Content-Type": "application/json", AuthToken: token },
        body: JSON.stringify({ Ticketid: Ticketid, newStatus: newStatus }),
      });
      let res = await data.json();
      console.log(res);
      return res;
    }

    async function CloseTicket() {
      let data = await fetch(`${apiurl}/Grievance/CloseTicket`, {
        method: "POST",
        headers: { AuthToken: token },
      });
      let res = await data.json();
      console.log(res);
      return res;
    }

    async function TotalTicketInfoForDashboard() {
      let data = await fetch(`${apiurl}/Grievance/TotalTicketInfo`, {
        method: "POST",
        headers: { AuthToken: token },
      });
      let res = await data.json();
      console.log(res);
      return res;
    }
    async function TicketForwardToHO(id) {
      let data = await fetch(`${apiurl}/Grievance/TicketForwardToHO`, {
        method: "POST",
        headers: { "Content-Type": "application/json", AuthToken: token },
        body: JSON.stringify({ Ticketid: id }),
      });
      let res = await data.json();
      console.log(res);
      return res;
    }
    async function GetHOComplaints() {
      let data = await fetch(`${apiurl}/Grievance/GetHOComplaints`, {
        method: "POST",
        headers: { AuthToken: token },
      });
      let res = await data.json();
      console.log(res);
      return res;
    }

    const TrackBills = async (type) => {
      try {
        let data = await fetch(apiurl + "/VendorManagement/TrackBills", {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({ type: type }),
        });
        data = await data.json();
        console.log("setTechnicalCount checking", data.length);
        return data;
      } catch (error) {
        console.error("Error in TrackBills:", error);
      }
    };
    const GenerateBankFile = async (selectedBillsArray, EToken) => {
      try {
        let data = await fetch(apiurl + "/BillApprovals/GenerateBankFile", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            AuthToken: token,
          },
          body: JSON.stringify({
            selectedBills: selectedBillsArray,
          }),
        });

        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GenerateBankFile:", error);
      }
    };
    const GetVendorInwardsList = async () => {
      console.log("GetVendorInwardsList called");

      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetVendorInwardsList",
          {
            method: "GET",

            headers: {
              AuthToken: token,
            },
          },
        );

        data = await data.json();

        return data;
      } catch (error) {
        console.error("Error in GetVendorInwardsList:", error);
      }
    };
    const VendorApprovalOperation = async (id, type, remark) => {
      console.log(id);

      try {
        let data = await fetch(
          apiurl + "/VendorManagement/VendorApprovalOperation",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              AuthToken: token,
            },
            body: JSON.stringify({ id: id, type: type, remark: remark }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in VendorApprovalOperation:", error);
      }
    };
    const GetStateBillSummary = async (fromDate = "", toDate = "") => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetStateBillSummary",
          {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ fromDate, toDate }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetStateBillSummary:", error);
      }
    };

    const GetDistrictwiseAccess = async (district, departmentId = null) => {
      try {
        const res = await fetch(
          `${apiurl}/VendorManagement/GetDistrictwiseAccess`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ district, departmentId }),
          },
        );
        return await res.json(); // { status, data | message }
      } catch (e) {
        console.error(e);
        return { status: false, message: "Network error" };
      }
    };

    const GetMyDepartmentAccess = async () => {
      console.log("GetMyDepartmentAccess called");
      try {
        const res = await fetch(
          `${apiurl}/VendorManagement/GetMyDepartmentAccess`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
          },
        );
        return await res.json(); // { status, data: { departments:[{id,name}] } }
      } catch (e) {
        return { status: false };
      }
    };

    const GetBillDeductions = async (departmentId = null) => {
      try {
        const res = await fetch(`${apiurl}/VendorManagement/GetBillDeductions`, {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({ departmentId }),
        });
        return await res.json();          // array of deduction rows, or { status:false, message }
      } catch (e) {
        return [];
      }
    };

    const GetDemandGenerationbyID = async (DemandGenerationID) => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetDemandGenerationbyID",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              AuthToken: token,
            },
            body: JSON.stringify({
              DemandGenerationID: DemandGenerationID,
            }),
          },
        );

        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetDemandGenerationbyID:", error);
      }
    };
    const GetWorkDetailbyworkID = async (WorkUniqueID) => {
      try {
        let data = await fetch(
          apiurl + "/vendormanagement/GetWorkDetailbyworkID",
          {
            method: "POST",

            headers: {
              "Content-Type": "application/json",
              AuthToken: token,
            },

            body: JSON.stringify({
              WorkUniqueID: WorkUniqueID,
            }),
          },
        );

        data = await data.json();

        return data;
      } catch (error) {
        console.error("Error in GetWorkDetailbyworkID:", error);
      }
    };
    const FetchECSFilesForTransfer = async () => {
      const res = await fetch(apiurl + "/ECSReport/FetchECSFilesForTransfer", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          AuthToken: token,
        },
      });
      return res.json();
    };
    const SendFund = async (files) => {
      try {
        let response = await fetch(apiurl + "/BillApprovals/SendFund", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            AuthToken: token,
          },
          body: JSON.stringify({ files }), // send selected files array
        });

        response = await response.json();
        return response;
      } catch (error) {
        console.error("Error in SendFund:", error);
      }
    };

    const uploadOldBills = async (tableData) => {
      try {
        let data = await fetch(apiurl + "/VendorManagement/uploadOldBills", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            AuthToken: token,
          },
          body: JSON.stringify({ tableData }),
        });

        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in uploadworkorder:", error);
      }
    };

    const GetOldBillsApproval = async (type = "") => {
      try {
        let data = await fetch(
          `${apiurl}/VendorManagement/GetOldBillsApproval`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              AuthToken: token,
            },
            body: JSON.stringify({
              type: type,
            }),
          },
        );

        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetOldBillsApproval:", error);
      }
    };

    const GetOldBillStateSummary = async (type) => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetOldBillStateSummary",
          {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ type: type }),
          },
        );
        data = await data.json();
        console.log("setTechnicalCount checking", data.length);
        return data;
      } catch (error) {
        console.error("Error in GetOldBillStateSummary:", error);
      }
    };

    const uploadVendorExcel = async (tableData) => {
      try {
        let data = await fetch(apiurl + "/VendorManagement/uploadVendorExcel", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            AuthToken: token,
          },
          body: JSON.stringify({ tableData }),
        });

        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in uploadVendorExcel:", error);
      }
    };

    const uploadworkorder = async (tableData) => {
      try {
        let data = await fetch(apiurl + "/VendorManagement/uploadworkorder", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            AuthToken: token,
          },
          body: JSON.stringify({ tableData }),
        });

        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in uploadworkorder:", error);
      }
    };
    const FetchDistrictFilter = async () => {
      console.log("FetchDistrictFilter called");

      try {
        let response = await fetch(apiurl + "/ECSReport/DistrictFilter", {
          method: "GET",
          headers: {
            AuthToken: token,
          },
        });

        console.log("Status:", response.status);

        const data = await response.json();

        console.log("Response:", data);

        return data;
      } catch (error) {
        console.error("Error:", error);
        return [];
      }
    };

    const RejectOrSendBackBill = async (
      selectedBills,
      remark,
      actionType,
      EToken,
    ) => {
      try {
        let data = await fetch(apiurl + "/BillApprovals/RejectOrSendBackBill", {
          method: "POST",
          headers: {
            AuthToken: token,
            EToken: EToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            selectedBills, // array of DemandGenerationID
            remark,
            actionType, // "Reject" | "SendBack"
          }),
        });

        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in RejectOrSendBackBill:", error);
      }
    };

    const GetBillByDemandID = async (demandId) => {
      console.log("GetBillByDemandID called with demandId:", demandId);
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetBillByDemandID/" + demandId,
          {
            method: "GET",
            headers: { AuthToken: token },
          },
        );
        return await data.json();
      } catch (error) {
        console.error("Error in GetBillByDemandID:", error);
      }
    };

    const EditDemandGeneration = async (payload) => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/EditDemandGeneration",
          {
            method: "POST",
            headers: {
              AuthToken: token,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          },
        );
        return await data.json();
      } catch (error) {
        console.error("Error in EditDemandGeneration:", error);
      }
    };

    const GetExistingWorkOrders = async () => {
      try {
        let data = await fetch(`${apiurl}/VendorManagement/GetProjectInfo`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            AuthToken: token,
          },
          body: JSON.stringify({
            ProjectID: "",
            type: "ExistingWorkOrders",
          }),
        });

        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error:", error);
      }
    };

    const GetRejectedWorksList = async ({
      filterDistrict = "",
      filterTaluka = "",
      filterYear = "",
      filterWorkType = "",
      filterWorkOrderType = "",
      filterStage = "",
    } = {}) => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetRejectedWorksList",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              AuthToken: token,
            },
            body: JSON.stringify({
              filterDistrict,
              filterTaluka,
              filterYear,
              filterWorkType,
              filterWorkOrderType,
              filterStage,
            }),
          },
        );

        data = await data.json();

        console.log("GetRejectedWorksList response:", data);

        return data;
      } catch (error) {
        console.error("Error in GetRejectedWorksList:", error);
        return {
          status: false,
          message: [],
        };
      }
    };

    const UploadExtensionOrder = async (formData) => {
      try {
        const res = await fetch(
          `${apiurl}/VendorManagement/UploadExtensionOrder`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("Token")}`,
            },
            body: formData,
          },
        );
        return await res.json();
      } catch (err) {
        console.error("UploadExtensionOrder error:", err);
        return { error: "Request failed" };
      }
    };
    const CheckWorkNameDuplicate = async (
      WorkName,
      ValidationContext,
    ) => {
      const response = await fetch(
        `${apiurl}/VendorManagement/CheckWorkNameDuplicate`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            AuthToken: token,
          },
          body: JSON.stringify({ WorkName, ValidationContext }),
        },
      );
      const result = await response.json();
 
      if (!response.ok) {
        throw new Error(result?.message || "Unable to validate Work Name");
      }
 
      return result;
    };

    return (
      <Application.Provider
        value={{
          Login,
          Authorizationverify,
          Authorizationreject,
          CreateToken,
          DashboardReports,
          CustomeReports,
          MisReports,
          Roles,
          EmployeeManagement,
          Usermenu,
          GetBillFiles,
          GetAdminPassKeys,
          AddAdminPassKeys,
          DeleteAdminPassKeys,
          DepartmentHandler,
          EditRoleActions,
          AuthorizationFiles,
          GetVendors,
          GetReport,
          AddBudget,
          GetBudget,
          BankMaster,
          UploadBills,
          GetBills,
          ApproveBills,
          GetVendorBills,
          TaxData,
          UpdateBudget,
          DeleteBudget,
          GetTaxAmounts,
          getTaxes,
          getTaxAmountsByDate,
          GetLogReports,
          GetSteelRates,
          GetDateWiseData,
          AddProduct,
          PurchaseList,
          GRCreation,
          HeadCreation,
          GetProjectInfo,
          GetBudgetHeadInfo,
          WorkOrderCreation,
          BudgetEstimation,
          DemandCreation,
          ReleaseFDUTF,
          ViewAllReleaseFDUTF,
          GetDemandApproval,
          GetAllProjectList,
          GetAllContractorList,
          GetAllBudgetHeadList,
          GetAllBudgetEstimationList,
          GetAllWorkOrderList,
          GetProjectTotal,
          GetLiabilityTotal,
          GetTotalAmountAvailbaleInBank,
          FundAllomentOperation,
          DeductionOperation,
          getGrnData,
          getBindata,
          AddExpenses,
          ApprovedOrRejectExpense,
          getecsreponsefiles,
          getecsresponse,
          GetCashBookReport,
          ProposalCreation,
          getGRNPendingList,
          GetTechnicalInwardsList,
          sanctionCreation,
          TechnicalSanctionApprove,
          GetAllUlb,
          GetGRPendingListForApprove,
          ApproveGR,
          GetProposallist,
          UploadFDUTF,
          GetPrograsslist,
          AdministrativeApprovalCreation,
          GetAdminApprovalInwardsList,
          AdministrativeApproveOperation,
          ProposalApprovalOperation,
          GetProposalInwardsList,
          WorkOrderApprovalOperation,
          GetWorkOrderInwardsList,
          DemandRequest,
          GetDemandRequestInwardsList,
          DemandRequestApprovalOperation,
          UploadFDUTF,
          ProgressReportApprovalOperation,
          GetBudgetEstimationInwardList,
          BudgetEstimationApprovalOperation,
          TechnicalOutwards,
          WorkOutwards,
          SchemeCreation,
          GetAllSchemes,
          FinanceGRApproveOperation,
          GetFinanceGRListForApprove,
          GetProgressReportInwardList,
          CreateMapCoordinateforProposal,
          Getyears,
          GetDemandOutwards,
          GetAdministativeoutwards,
          EditDraftCopy,
          getcaptcha,
          validatecaptcha,
          GetGramPanchayatCodes,
          TypesOfWork,
          GetTechnicalCoordinates,
          allProposals,
          allworkordercount,
          alltechnicalCount,
          allbillcount,
          GetOverLappingData,
          FetchECSFiles,
          FetchECSReport,
          FetchECSDashboardReport,
          FetchFilesForUpdate,
          saveECSFile,
          SecureFileFetching,
          GetProgressReportOutwardsFucntion,
          GetDemandRequestOutwardsFunction,
          NotificationHandler,
          GRProposalCreationFunction,
          CheckGRNumberFunction,
          GetProposalStatusList,
          GetTotalTableData,
          GetAllProposalList,
          GetGRbyProposalId,
          RaiseAcomplaint,
          GetComplaints,
          UserTicketInfo,
          ShowMessages,
          SendTicketChatDMA,
          GetTicketInfos,
          CloseTickets,
          CloseTicket,
          TotalTicketInfoForDashboard,
          ReopentheTicket,
          TicketForwardToHO,
          GetHOComplaints,
          GetWorkStatusReportData,
          GetWorksByGR,
          TrackBills,
          GenerateBankFile,
          GetVendorInwardsList,
          VendorApprovalOperation,
          GetStateBillSummary,
          GetDemandGenerationbyID,
          GetWorkDetailbyworkID,
          validateOtp,
          SendFund,
          FetchECSFilesForTransfer,
          uploadOldBills,
          GetOldBillsApproval,
          GetOldBillStateSummary,
          uploadVendorExcel,
          uploadworkorder,
          FetchDistrictFilter,
          RejectOrSendBackBill,
          GetBillByDemandID,
          EditDemandGeneration,
          GetExistingWorkOrders,
          GetRejectedWorksList,
          UploadExtensionOrder,
          GetDistrictwiseAccess,
          GetMyDepartmentAccess,
          GetBillDeductions,CheckWorkNameDuplicate
        }}
      >
        {props.children}
      </Application.Provider>
    );
  } catch (error) {
    console.error("Error in AdminState:", error);
    throw error;
  }
};
export default AdminState;
